export const section3DetailsList = [
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section3_img1.png',
    step: 'POINT 1',
    title: '실제 기업과 협업하는 마케팅 \n프로젝트 진행',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section3_img2.png',
    step: 'POINT 2',
    title: '누구나 데이터 친화적인 마케터로 \n성장할 수 있는 단계별 커리큘럼',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section3_img3.png',
    step: 'POINT 3',
    title: '하반기 공채에 맞춰 빈틈없이 설계된 \n취업지원 프로그램',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section3_img4.png',
    step: 'POINT 4',
    title: '그로스 마케터 정규직 전환형 \n인턴십 기회 제공',
  },
]

export const curriculumDetailList = [
  {
    id: 1,
    step: '1주차',
    titlePc: '그로스 마케팅과 데이터 분석 \n기초',
    titleM: '그로스 마케팅과 데이터 분석 기초',
    desc: '그로스 마케팅의 개념과 데이터의 역할을 배우고, Python을 활용한 데이터 분석 기초를 학습합니다.',
    descList: [
      '데이터를 활용하여 마케팅 성과를 극대화하는 방법에 대한 이해',
      '효과적인 마케팅 전략을 세우는 기본적인 사고방식 학습',
      '데이터를 바탕으로 정확하고 논리적인 의사 결정 역량 강화',
      '데이터 분석에 필요한 Python 프로그래밍 기술의 기초 학습',
      'Python 제어문을 통한, 데이터를 처리하고 분석하는 논리적인 사고를 개발할 수 있는 역량 강화',
      '데이터 분석 구조 수립을 위한 Python 함수와 파일 처리, 모듈과 패키지 정리',
    ],
  },
  {
    id: 2,
    step: '2-3주차',
    titlePc: '실천적인 데이터 분석 방법론 \n기본',
    titleM: '실천적인 데이터 분석 방법론 기본',
    desc: 'Pandas와 SQL을 활용한 데이터 분석 및 클라우드 환경에서의 데이터베이스 활용법을 학습합니다.',
    descList: [
      'Pandas 기초 및 데이터 로드와 기본 탐색을 통해 데이터를 불러오고 기본적으로 분석하는 능력 강화',
      '데이터 정렬과 그룹화, 집계 방법론 실습을 통한 데이터를 효율적으로 정리하고 요약하는 방법 학습',
      'GCP VM 설정 및 Maria DB의 설치하여 클라우드 환경에서 데이터베이스를 설정하고 활용하는 방법에 대한 학습',
      'SQL 기본 문법 및 데이터베이스에서 데이터를 검색하고 처리하는 기본 기술에 대한 학습',
      '다양한 데이터를 구조화 및 그룹화하여 체계적으로 정리하고 관계를 이해하는 방법 학습',
      '고급 SQL과 Python을 함께 사용하여 데이터 분석 자동화를 구현',
      'Pandas와 SQL 활용 데이터 분석 미니 프로젝트를 통한 실무 역량 강화',
    ],
  },
  {
    id: 3,
    step: '3-4주차',
    titlePc: '데이터 수집 및 전처리, \n통계 분석',
    titleM: '데이터 수집 및 전처리, 통계 분석',
    desc: '웹 크롤링, API를 통한 데이터 수집과 데이터 전처리 및 통계분석, 예측 모델을 실습합니다.',
    descList: [
      '통계의 기본 개념을 이해하여 데이터를 분석하고 해석하는 기초 능력 향상',
      '웹 크롤링 개요 및 원하는 웹 데이터를 자동으로 수집하는 방법 학습',
      '동적 페이지에서 필요한 데이터를 효율적으로 크롤링하고 저장하는 방법 학습',
      'API 개념 및 다양한 서비스에서 데이터를 쉽게 가져오는 방법에 대한 이해',
      '설문조사를 통한 고객 행동 데이터를 수집하고 분석하는 학습',
      '데이터 전처리 품질 향상 및 분석 준비 학습',
      '데이터 분포와 확률, 회귀 분석의 개념',
      '단순 회귀와 다중 회귀 분석 실습을 통해 문제 예측 및 해결',
      '상관 관계 이해 및 심화 상관 분석',
    ],
  },
  {
    id: 4,
    step: '4-6주차',
    titlePc: '마케팅 성과 예측을 위한 \n통계 분석',
    titleM: '마케팅 성과 예측을 위한 통계 분석',
    desc: '마케팅 성과를 분석하고 예측 모델을 통해 마케팅 결과를 개선하는 방법을 학습합니다.',
    descList: [
      '마케팅 데이터 주요 지표 분석 방법론',
      '고객 그룹을 세분화(Segmentation)하여 맞춤형 전략 수립',
      '데이터 기반으로 마케팅 결과 예측 및 개선',
      '실제 데이터를 분석하고 활용하는 미니 프로젝트',
    ],
  },
  {
    id: 5,
    step: '6주차',
    titlePc: '마케팅 대시보드',
    titleM: '마케팅 대시보드',
    desc: 'Tableau와 Looker Studio를 활용한 시각화 및 대시보드 설계 방법을 배웁니다.',
    descList: [
      'Tableau와 Looker Studio 활용하여 데이터 시각화를 통한 효과적인 인사이트 전달',
      'Tableau 사용법 학습 및 직관적인 시각화 및 설계',
      'Looker Studio 개요와 다양한 데이터 소스를 연결해 실시간 분석 환경 구축',
      'Looker Studio 시각화 및 사용자 친화적인 대시보드를 설계를 통한 데이터 활용도 향상',
    ],
  },
  {
    id: 6,
    step: '7-8주차',
    titlePc: '머신러닝의 이해',
    titleM: '머신러닝의 이해',
    desc: '정교한 타겟팅, 자동화된 캠페인 최적화, 개인화된 고객 경험 구현을 위한 머신러닝 기법을 배우고, 예측 및 분류 모델을 실습합니다.',
    descList: [
      '머신러닝의 기본 개념 이해',
      '데이터 전처리와 특징 엔지니어링',
      '선형 회귀 및 다중 선형 회귀, 로지스틱 회귀의 개념과 활용',
      '모델의 정확도를 평가하고 개선할 수 있는 역량 향상',
      '결정 트리의 기본 개념 및 데이터를 시각적으로 분류하고 예측하는 방법 학습',
      '랜덤 포레스트 개념 및 구현을 통해 여러 의사결정 트리를 결합하는 방법 학습',
      'K-평균 군집화와 계층적 군집 분석',
      '회귀 분석을 통한 시간에 따라 변하는 데이터를 분석을 통한 미래 예측',
      '인공 신경망의 기본 구조 및 역전파와 딥러닝 모델 학습 기초',
      'LSTM의 이해와 마케팅 데이터 활용 실습',
    ],
  },
  {
    id: 7,
    step: '8-9주차',
    titlePc: '마케팅 심화1 : 그로스 마케팅 \n주요 개념',
    titleM: '마케팅 심화1 : 그로스 마케팅 \n주요 개념',
    desc: '그로스 마케팅 전략, KPI 분석, 고객 여정 설계 및 세그먼트 정의, 소셜 미디어 활용법을 배웁니다.',
    descList: [
      '마케팅 방법론으로서의 마케팅 전략을 설계하고 실현하는 방법 학습',
      '그로스 마케팅의 전통 마케팅과의 차이점',
      '그로스해킹의 배경과 마케팅에서의 적용 사례 학습',
      '그로스 마케팅에 있어서 고객 여정(Consumer Journey)의 이해',
      '마케팅 핵심 지표(KPI)와 데이터 분석',
      '고객을 유입하고 전환시키는 마케팅 퍼널 분석을 통한 전략 최적화',
      'AARRR 프레임워크를 통해 고객 획득, 활성화, 유지, 추천, 수익화 과정을 효과적으로 관리하는 방법 학습',
      '고객 획득 전략 수립 1 : 고객 여정 설계 스토리텔링 콘텐츠 전략 수립',
      '고객 획득 전략 수립 2 : 데이터 기반 고객 세그먼트의 정의',
      '고객 획득 전략 수립 3 : 소셜 미디어와 커뮤니티의 활용 방법론',
    ],
  },
  {
    id: 8,
    step: '9-11주차',
    titlePc: '미드 프로젝트',
    titleM: '미드 프로젝트',
    desc: '탄소배출권 거래소 그로스해킹 전략 수립 및 분석 실습을 통해 실무 역량을 강화합니다.',
    descList: [
      '고객 페르소나 정의 - 탄소배출권 구매 가능성이 높은 유저 그룹 정의 및 발굴',
      '신규 고객을 위한 맞춤형 랜딩페이지 개설',
      '검색 엔진 최적화(SEO) 적용',
      '트래픽 확보를 위한 Paid 마케팅 진행',
      '탄소배출권 구매 가이드 제작 등 트래픽 증가를 위한 콘텐츠 마케팅 병행',
      'GA4 분석 및 랜딩페이지 방문자 데이터 분석을 통한 이탈율 개선 전략 도출',
    ],
  },
  {
    id: 9,
    step: '12-13주차',
    titlePc: '마케팅 심화2 : 그로스 마케팅의 \n프레임워크 심화 학습 및 실습',
    titleM: '마케팅 심화2 : 그로스 마케팅의 \n프레임워크 심화 학습 및 실습',
    desc: '전환율 최적화, A/B 테스트, 개인화 마케팅, CRM 및 마케팅 자동화 도구를 활용한 고객 경험 개선과 유지 전략을 배웁니다.',
    descList: [
      '전환율 최적화(CRO)를 통해 웹사이트 방문자를 실제 고객으로 전환시키는 전략 학습',
      'A/B 테스트와 다양한 전략을 실험하여 최적의 마케팅 방법 도출',
      '웹사이트 및 랜딩 페이지의 최적화(Optimization)',
      '개인화 마케팅 학습 및 설계',
      'CRM 도구를 활용한 고객 경험 향상',
      '행동 분석 도구를 통한 인사이트의 확보',
      '고객 유지 (Retention) 전략 설계',
      '고객의 충성도 프로그램 및 재참여 유도 방법론',
      '마케팅 자동화 도구 개념과 활용',
      '전환 강화를 위한 데이터 중심 고객 인사이트 활용법',
    ],
  },
  {
    id: 10,
    step: '14-18주차',
    titlePc: '파이널 프로젝트',
    titleM: '파이널 프로젝트',
    desc: '운동 관리 플랫폼의 실제 데이터를 활용한 유저 이탈 방지 및 글로벌 마케팅 전략 수립으로 기업 비즈니스 성장을 위한 실전 경험을 쌓습니다.',
    descList: [
      '검색 트렌드 데이터 분석 후 타켓 키워드 선정',
      'Application Push 기능 활용을 통한 유저 행동 데이터 기반 개인화 메시지 최적화',
      '유저 세그먼트 기반 맞춤형 이메일 설계 및 캠페인 진행',
      'Paid 마케팅 및 검색 엔진 최적화(SEO) 적용',
      '마케팅 툴을 활용한 광고 소재 제작',
      '광고 고효율 소재 분석 및 개선안 제시',
      '프로젝트 활동 관련 별도 랜딩 페이지 제작',
      '유저 유입 및 재방문 데이터 기반 맞춤형 프로모션 기획',
      '랜딩페이지 방문자 데이터 분석을 통한 유입 경로 분석 및 이탈율 개선 전략 도출',
    ],
  },
]

export const curriculumBenefitList = [
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section7_img1_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section7_img1_m.png',
    title: '사전 학습 VOD 제공',
    desc: '그로스 마케팅이 적성과 맞을지 단기간에 파악하고 싶다면? 사전 학습 VOD 시청으로 직무의 핵심을 미리 맛보세요.',
    descList: [
      {
        linkText: 'AI 활용 콘텐츠 마케팅',
        linkUrl: 'https://likelion.net/courses/technology/next-AImarketing',
      },
      {
        linkText: '데이터 애널리틱스 입문',
        linkUrl: 'https://likelion.net/courses/technology/next-analytics',
      },
      {
        linkText: '차트 분석 및 대시보드 제작',
        linkUrl: 'https://likelion.net/courses/technology/next_GA4',
      },
    ],
  },
  {
    imgUrlPc: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section7_img2.gif',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section7_img2.gif',
    title: '그로스 수업 진행',
    desc: '정규 교육과정 외 매주 2시간 희망자에 한해 데이터 분석 강사님과 함께 복습을 진행해요. 반복 설명을 통해 이해가 될 때까지 차근차근 알려드려요.',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section7_img3_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section7_img3_m.png',
    title: '직무 특강',
    desc: '멋쟁이사자처럼 현직 그로스 마케터가 직접 광고 매체, CRM, 데이터 분석 관련 주제로 특강을 진행해요. 현직자 멘토의 생생한 업무 경험과 함께 커리어 관리를 위한 실질적인 노하우를 전수해드려요.',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section7_img4_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section7_img4_m.png',
    title: '스터디 운영',
    desc: '보조강사님의 체계적인 관리로 운영되는 스터디에 자율적으로 참여할 수 있어요. SQLD 자격증 취득, 마케팅 블로그 운영 등 원하는 목표가 있다면 동료들과 함께 하는 스터디를 놓치지 마세요.',
  },
]

export const section9DetailsList = [
  {
    step: '1',
    title: '그로스 마케터',
    descList: [
      '유입 및 전환 단계에서 데이터 분석을 통한 인사이트 추출',
      '분석을 위한 대시보드 설계 및 자동화',
    ],
  },
  {
    step: '2',
    title: '퍼포먼스 마케터',
    descList: [
      '광고 매체 미디어 믹스 및 타게팅, 소재 기획',
      '데이터 분석을 통한 가설 수립 및 캠페인 성과 분석',
    ],
  },
  {
    step: '3',
    title: 'CRM 마케터',
    descList: ['고객 세그먼트별 CRM 채널 운영', '고객 여정에 대한 유저 기반 가설 수립'],
  },
]

export const supportBenefitList = [
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section10_img1_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section10_img1_m.png',
    step: '4월',
    title: '사전 학습',
    desc: '기초 학습 VOD 제공',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section10_img2_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section10_img2_m.png',
    step: '5월',
    title: '교육 1개월차',
    descList: ['자기 탐색', '도메인 설정', '취업 준비 로드맵 수립'],
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section10_img3_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section10_img3_m.png',
    step: '6월',
    title: '교육 2개월차',
    desc: '이력서, 자기소개서, 포트폴리오 작성 가이드 제공',
    point: [
      {
        pointTitle: '취업 특강',
        pointDesc: '변화된 채용트렌드를 반영한 효과적인 취업 준비 방안',
      },
    ],
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section10_img4_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section10_img4_m.png',
    step: '7월',
    title: '교육 3개월차',
    desc: '이력서, 자기소개서, 포트폴리오 초안 작성',
    point: [
      {
        pointTitle: '취업 특강',
        pointDesc: '토론 중심 모의 면접 시뮬레이션',
      },
    ],
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section10_img5_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section10_img5_m.png',
    step: '8월',
    title: '교육 4개월차',
    descList: [
      '이력서, 자기소개서, 포트폴리오 피드백 제공 및 완성본 제작',
      '마케팅 자동화 유료 VOD 무료 제공 (수료생 대상)',
    ],
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section10_img6_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section10_img6_m.png',
    step: '9월~',
    title: '하반기 공채 시작',
    descList: [
      'IT 맞춤형 채용설명회 진행',
      '우수 수료생 대상 채용 연계',
      '우수 수료생 대상 인턴십 기회 제공',
      '면접 준비 1:1 멘토링',
    ],
  },
]

export const benefitList = [
  {
    title: '마케팅 광고비 지원',
    desc: '프로젝트 진행 시, 광고 캠페인 집행에 들어가는 비용을 지원해요.',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section14_benefit_img1_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section14_benefit_img1_m.png',
  },
  {
    title: '마케팅 자동화 VOD 무료 제공',
    desc: '수료생을 대상으로 ‘생성형 AI를 활용한 CRM & 마케팅 자동화’ 유료 강의를 무료 제공해요.',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section14_benefit_img2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section14_benefit_img2_m.png',
  },
  {
    title: '교육비 전액 무료',
    desc: '내일배움카드로 1,103만원 상당의 교육을 무료로 들을 수 있어요.',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section14_benefit_img3_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section14_benefit_img3_m.png',
  },
  {
    title: '훈련장려금 지급',
    desc: '매월 최대 81만원 상당의 훈련장려금이 지급돼요.',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section14_benefit_img4_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section14_benefit_img4_m.png',
  },
  {
    title: '오프라인 학습 공간 지원',
    desc: '사전 신청자에 한하여 오프라인 학습 공간을 지원해요.',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section14_benefit_img5_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section14_benefit_img5_m.png',
  },
]

export const reviewList = [
  {
    review: '친절하고 전문적인 강사님, 소통능력과 동기부여 전달력 최고이십니다!',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section15_img1.png',
  },
  {
    review:
      '강사님께서 강의 경력이 매우 많으셔서 강의 진행도 깔끔하시고 현업 경력도 있으셔서 \n앞으로의 커리어에 있어 도움이 될 만한 이야기들을 다양하게 해주셔서 좋았습니다.',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section15_img2.png',
  },
  {
    review: '이해하기 쉽고 상세하게 설명해주셔서 재미있게 수강하고 있습니다 :)',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section15_img3.png',
  },
  {
    review: '피드백을 적극 수용해주신다고 느낍니다. 최고의 강사님이십니다.',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section15_img4.png',
  },
  {
    review:
      '강사님 덕분에 왕초보도 많은 것들 배우고 있습니다! 항상 어려운 과정 잘하고 있다고 해주셔서 힘들어도 꾸준히 해나가고 있어요.',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section15_img5.png',
  },
  {
    review: '동기부여는 매일 항상 열의를 가지고 해주시는게 수강생들이게 잘 전달이 됩니다.',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section15_img6.png',
  },
  {
    review:
      '저는 이번주 진도 너무 만족했고, 강사님이랑 헤어질 생각에 벌써부터 약간 슬플 때도 있습니다. \n(파워 I라서 익명의 힘을 빌려 마음을 전하는...)',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-growth-2nd/section15_img7.png',
  },
]

export const ApplyScheduleList = [
  {
    title: '서류 \n합격자 \n발표일',
    content: '매주 목요일 오후 3시 \n(전일 오후 1시 이전 제출자에 한함)',
    contentList: [
      '1차 : 3.27(목) 오후 3시',
      '2차 : 4.3(목) 오후 3시',
      '3차 : 4.10(목) 오후 3시',
      '4차 : 4.17(목) 오후 3시',
      '5차 : 4.24(목) 오후 3시',
    ],
  },
  {
    title: '최종 결과 \n발표',
    content: '서류 합격자 안내 메일 참고 부탁드립니다.',
  },
]

export const EduScheduleList = [
  {
    title: '학습 형태',
    content: '실시간 온라인 교육',
  },
  {
    title: '참고 사항',
    content:
      '국민내일배움카드로 K-Digital Training 과정에 참여할 수 있는 분만 수강 가능합니다. \n매달 출석률에 따라 훈련장려금이 차등 지급됩니다.',
  },
]

export const bootCampFaqTabList = [
  { label: '전체', value: 'all' },
  {
    label: '지원',
    value: 'apply',
  },
  {
    label: '선발',
    value: 'nebeka',
  },
  {
    label: '취업',
    value: 'employment',
  },
  {
    label: '교육운영',
    value: 'edu',
  },
  {
    label: '특전혜택',
    value: 'benefit',
  },
  {
    label: '기타',
    value: 'etc',
  },
]

interface IBootCampFaqList {
  [key: string]: {
    question: string
    answer?: string
    secondAnswer?: string
    externalUrl1?: string
    urlName1?: string
    externalUrl2?: string
    urlName2?: string
    answerList?: string[]
  }[]
}

export const bootCampFaqList: IBootCampFaqList = {
  apply: [
    {
      question: '[지원] 지원 자격이 있나요?',
      answer:
        '국민내일배움카드를 보유하고 있거나 발급 가능하다면 누구든지 지원하실 수 있습니다. 발급 가능 여부는 고용노동부 1350 또는 거주지 관할 고용센터에서 직접 확인해주셔야 합니다. \n국민내일배움카드를 발급받고 교육 기간 동안 주 5일, 매일 약 8시간의 교육 과정에 온전히 참여하실 수 있다면 원칙상 수강할 수 있으나, 직장과 병행해야 해서 정해진 시간에 출석할 수 없고 하루 8시간의 학습 시간을 채울 수 없는 경우 선발에서 제외됨을 알려드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드가 없어도 지원할 수 있나요?',
      answer:
        '지원은 가능합니다. 다만 최종 합격 발표 전까지는 모바일 앱 카드 혹은 실물 카드를 소지하고 있으셔야 합니다. \n모바일 앱 카드의 경우, 신청 당일에 즉시 발급이 가능하지만 오프라인 카드 발급은 최종 수령까지 일주일 이상 소요될 수 있기에 고용노동부 1350을 통해 카드 발급 자격 확인 및 발급 신청을 빠르게 하시는 것을 추천드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드는 반드시 오프라인에서만 발급 받을 수 있나요?',
      answer:
        '국민내일배움카드는 고용24 홈페이지를 통해 신청 가능하며 오프라인과 온라인 모두 발급 받으실 수 있습니다. \n자세한 발급 과정은 아래 링크를 통해 확인 가능합니다.',
      externalUrl1: '/nebeca',
      urlName1: '국민내일배움카드 신청 방법 확인하기 (링크)',
      externalUrl2: '/nebeca/issued',
      urlName2: '국민내일배움카드 모바일 발급 방법 확인하기 (링크)',
    },
    {
      question: '[지원] 고용24 수강신청은 언제 할 수 있나요?',
      answer:
        '최종 합격자로 선발된 후, 합격하신 분들께 별도로 안내해 드릴 예정입니다. \n안내를 받으신 후 고용24에서 신청해주시면 됩니다.',
    },
    {
      question: '[지원] 비전공자도 지원 가능한가요?',
      answer:
        '네. 지원 가능합니다. 전공과 무관하게 그로스 마케터가 되려는 강한 의지와 계획이 있으시면 됩니다. \n다만, 합격 후 약 4개월 동안 정말 몰입해서 학습을 이어가셔야 합니다. 꾸준한 의지와 학습 습관으로 목표하시는 변화를 만들어내시기 바랍니다.',
    },
    {
      question: '[지원] 지원서 제출 후 수정 가능한가요?',
      answer: '지원서 수정은 불가능합니다. 항목을 미리 검토하신 후 제출하시기 바랍니다.',
    },
    {
      question: '[지원] 다른 부트캠프와 중복 지원 가능한가요?',
      answer:
        '멋쟁이사자처럼이 운영하는 다른 부트캠프와 중복 지원은 불가합니다. 다른 훈련기관이 운영하는 과정에 중복 지원하는 것은 가능합니다. 희망하는 부트캠프에 한해 하나만 지원 가능하므로 신중하게 고민하고 선택해주세요.',
    },
    {
      question: '[지원] 미성년자도 지원이 가능한가요?',
      answer: '아쉽지만 미성년자는 지원이 어렵습니다.',
    },
  ],
  nebeka: [
    {
      question: '[선발] 선발 절차는 어떻게 되나요?',
      answer:
        '국민내일배움카드 신청 → 1차 지원서(서류) 제출 → 최종합격자 발표 → 고용24 수강신청 순으로 진행됩니다. \n국민내일배움카드 발급에 일주일 이상 소요되므로 발급 신청을 먼저 해주시기 바랍니다.',
    },
    {
      question: '[선발] 합격 확인은 어떻게 하나요?',
      answer:
        '각 단계별로 합격하신 분들께는 E-mail과 SMS로 안내드릴 예정입니다. 발표 일정은 상세페이지를 참고해주세요. \n*발표 일정은 상황에 따라 일부 변경될 수 있습니다.',
    },
  ],
  employment: [
    {
      question: '[취업] 취업 지원 프로그램이 제공되나요?',
      answer:
        '최신 채용 트렌드를 반영한 전문적인 이력서 및 포트폴리오 특강과 1:1 피드백을 통해 체계적인 취업 지원을 받으실 수 있습니다. 수료 후에도 지속적인 케어와 인턴십·채용 연계 기회를 제공합니다. \n제공되는 프로그램 항목은 내부 사정에 의해 변경될 수 있으며 자세한 내용은 상세페이지를 참고해 주세요.',
    },
  ],
  edu: [
    {
      question: '[교육 운영] 교육은 어디서 진행되나요?',
      answer:
        '교육은 오프라인이 아닌, 온라인 라이브로 진행되며 국내에서, 거주 지역에 무관하게 학습할 수 있습니다.',
    },
    {
      question: '[교육 운영] 온라인 수업 출결은 어떻게 진행되나요?',
      answer:
        '두 가지 방법으로 출결이 진행됩니다. \n1. 고용24 앱 설치 후 QR코드 인증(개인 진행) \n2. 줌 모니터링을 통한 매시간 출결 체크(운영진 진행, 줌 화면에 얼굴이 정확히 확인되어야 출석 인정) \n추가로, 수업 참여 중 장소 이동은 불가합니다. 장소 이동 시 출결에 불이익이 발생하니 이점 유의 부탁드립니다.',
    },
    {
      question: '[교육 운영] 수업에 빠질 경우 강의를 다시 볼 수 있나요?',
      answer:
        '본 교육 과정은 학습을 포함한 모든 내용을 영상으로 추가 제공하지 않습니다. 따라서 다음 수업 내용을 잘 따라가기 위해서는 반드시 출석해주셔야 합니다.',
    },
    {
      question: '[교육 운영] 교육 기간 중 쉬는 날은 없나요?',
      answer:
        '교육 기간 내 주말, 공휴일에는 교육을 진행하지 않습니다. 수업 외 일정에 관해서는 오리엔테이션에서 자세하게 안내드릴 예정입니다. 교육기간 4개월동안 온전하게 몰입하시는 것을 권유드립니다.',
    },
    {
      question: '[교육 운영] 해외에서도 참여할 수 있나요?',
      answer:
        'KDT 프로그램의 특성상, 해외에서 수강하는 것은 불가능합니다. 교육 참여 중에 해외로 이동하는 것 역시 불가능합니다.',
    },
  ],
  benefit: [
    {
      question: '[특전 혜택] 합격생에게 제공되는 혜택이 있나요?',
      answerList: [
        '· 멋쟁이사자처럼 수료생 커뮤니티 활동 기회를 제공합니다.',
        '· 수료 후 정기적으로 진행되는 행사참여 및 네트워킹 기회를 제공합니다. (KDT 수료생에 한함)',
        '· 이력서 특강 등 개인 맞춤 성장 프로그램을 제공합니다.',
      ],
    },
  ],
  etc: [
    {
      question: '[기타] 훈련장려금을 받을 수 있나요?',
      answer: '네. 월 최대 810,000원까지 받으실 수 있으며, 매달 출석률에 따라 차등 지급됩니다.',
    },
    {
      question: '[기타] 훈련 자비 부담액은 얼마인가요?',
      answer: '본 교육과정은 내일배움카드를 소지하신 분들을 대상으로 전액 무료로 진행됩니다.',
    },
  ],
}
